import {
  maintenanceWorkOrderListQuerySchema,
  type MaintenanceWorkOrderListQuery,
} from '@gb-ticket/shared-types';

import { toSearchParams } from '@/lib/format';
import { MAINTENANCE_TRASH_PATH } from '@/products/maintenance/maintenance-paths';

export const DEFAULT_MAINTENANCE_TRASH_QUERY: MaintenanceWorkOrderListQuery = {
  page: 1,
  pageSize: 25,
  sortBy: 'scheduledFor',
  sortOrder: 'asc',
  includeArchived: false,
};

export function maintenanceTrashPath(patch: Partial<MaintenanceWorkOrderListQuery> = {}): string {
  const query = { ...DEFAULT_MAINTENANCE_TRASH_QUERY, ...patch };
  return `${MAINTENANCE_TRASH_PATH}${toSearchParams({
    page: query.page,
    pageSize: query.pageSize,
    sortBy: query.sortBy,
    sortOrder: query.sortOrder,
    status: query.status,
    assignedToId: query.assignedToId,
    customerId: query.customerId,
    scheduledFrom: query.scheduledFrom,
    scheduledTo: query.scheduledTo,
  })}`;
}

export function maintenanceTrashQueryFromSearch(search: string): MaintenanceWorkOrderListQuery {
  const params = {
    page: String(DEFAULT_MAINTENANCE_TRASH_QUERY.page),
    pageSize: String(DEFAULT_MAINTENANCE_TRASH_QUERY.pageSize),
    sortBy: DEFAULT_MAINTENANCE_TRASH_QUERY.sortBy,
    sortOrder: DEFAULT_MAINTENANCE_TRASH_QUERY.sortOrder,
    ...Object.fromEntries(new URLSearchParams(search)),
  };
  const parsed = maintenanceWorkOrderListQuerySchema.safeParse(params);
  return parsed.success ? parsed.data : DEFAULT_MAINTENANCE_TRASH_QUERY;
}
